import {
  AfterViewInit, Component, computed, ElementRef, input, OnDestroy, Signal,
  signal, ViewChild,
} from '@angular/core';
import { EventInfo } from 'in-time-core';
import { findScrollProgressOfElement, scrollOneLeft, scrollOneRight } from '../../../../ui/utility/carousel-utils';
import { LeftRightButtonPairMode } from '../../../../ui/components/left-right-button-pair/left-right-button-pair.component';

const MAX_SCROLL_STEPS = 5;

@Component({
  selector: 'app-big-event-card-carousel',
  templateUrl: './big-event-card-carousel.component.html',
})
export class BigEventCardCarouselComponent implements AfterViewInit, OnDestroy {
  public readonly events = input.required<EventInfo[]>();

  @ViewChild('scrollable', { static: true }) scrollableDiv!: ElementRef<HTMLDivElement>;

  public readonly scrollSteps = computed(() => {
    return Math.min(this.events().length, MAX_SCROLL_STEPS);
  });

  public readonly scrollPercentage = signal<number>(0);

  public readonly buttonMode: Signal<LeftRightButtonPairMode> = computed(() => {
    const scrollPercentage = this.scrollPercentage();
    if(scrollPercentage <= 0) {
      return 'right';
    }
    else if(scrollPercentage >= 1) {
      return 'left';
    }
    else {
      return 'both';
    }
  });

  ngAfterViewInit(): void {
    this.scrollableDiv.nativeElement.onscroll = () => {
      const result = findScrollProgressOfElement(this.scrollableDiv.nativeElement);

      this.scrollPercentage.set(result);
    };
  }

  ngOnDestroy(): void {
    this.scrollableDiv.nativeElement.onscroll = null;
  }

  onScrollLeft(): void {
    scrollOneLeft(this.scrollableDiv.nativeElement);
  }

  onScrollRight(): void {
    scrollOneRight(this.scrollableDiv.nativeElement);
  }
}
